import { ClipboardList, BarChart3, Lightbulb } from "lucide-react";
import LotusIcon from "./icons/LotusIcon";

const steps = [
  {
    icon: ClipboardList,
    title: "Answer 25 Life Questions",
    description: "Thoughtfully designed questions exploring the five dimensions of your life based on ancient Kosha wisdom.",
    step: "01"
  },
  {
    icon: BarChart3,
    title: "Get Instant Analysis",
    description: "Receive a comprehensive breakdown across all 5 Koshas showing your life strengths and growth areas.",
    step: "02"
  },
  {
    icon: Lightbulb,
    title: "Personalized Recommendations",
    description: "Get tailored coaching insights, Vedantic wisdom, and actionable steps to transform your life.",
    step: "03"
  }
];

export const LifeHowItWorks = () => {
  return (
    <section className="py-12 md:py-16 bg-gradient-to-b from-background to-sage-dark mandala-bg">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-10">
          <div className="lotus-divider">
            <LotusIcon size={32} />
          </div>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-4">
            How It Works
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            A simple, sacred journey to understanding your life's deepest dimensions
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <div
              key={index}
              className="card-spiritual text-center group hover:scale-105 transition-all duration-300 relative"
            >
              {/* Step Number */}
              <div className="absolute -top-4 -right-4 w-12 h-12 bg-accent text-accent-foreground rounded-full flex items-center justify-center font-serif text-lg font-bold shadow-lg">
                {step.step}
              </div>

              {/* Icon */}
              <div className="w-20 h-20 mx-auto mb-6 bg-primary/10 rounded-2xl flex items-center justify-center group-hover:bg-accent/20 transition-colors">
                <step.icon className="w-10 h-10 text-primary group-hover:text-accent transition-colors" />
              </div>

              {/* Content */}
              <h3 className="font-serif text-xl md:text-2xl font-semibold text-primary mb-3">
                {step.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {step.description}
              </p>

              {/* Connector Line (except last) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-0.5 bg-accent/30" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LifeHowItWorks;
